import Button from '../base/Button';

export default function Contact() {
  return (
    <section id="contato" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#5A5A5A] mb-4">
            Fale com o <strong className="text-[#6B2432]">Dr. Luiz Renato Kreb</strong>
          </h2>
          <p className="text-lg text-[#5A5A5A] max-w-3xl mx-auto mb-8">
            Atendimento rápido e personalizado pelo WhatsApp. 
            Entre em contato agora e agende sua consulta com Dr. Luiz Renato Kreb.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Main CTA */}
          <div className="text-center mb-16">
            <Button
              href="https://wa.me/5544999297166"
              size="lg"
              icon={<i className="ri-whatsapp-line text-2xl animate-pulse"></i>}
              className="text-xl px-12 py-6 mb-4"
              pulse
            >
              Iniciar Conversa com Dr. Luiz
            </Button>
            <p className="text-[#6B2432] font-semibold text-lg">
              (44) 99929-7166
            </p>
          </div>

          {/* Contact Options */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {/* WhatsApp */}
            <div className="text-center p-8 bg-[#F5F5F5] rounded-lg hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-whatsapp-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-[#5A5A5A] mb-2">WhatsApp</h3>
              <p className="text-[#5A5A5A] mb-4">Atendimento rápido e direto</p>
              <a 
                href="https://wa.me/5544999297166"
                className="text-[#6B2432] font-semibold hover:underline"
              >
                (44) 99929-7166
              </a>
            </div>

            {/* Phone */}
            <div className="text-center p-8 bg-[#F5F5F5] rounded-lg hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[#6B2432] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-[#5A5A5A] mb-2">Telefone</h3>
              <p className="text-[#5A5A5A] mb-4">Ligue para agendar</p>
              <a 
                href="tel:+554430268859"
                className="text-[#6B2432] font-semibold hover:underline"
              >
                (44) 3026-8859
              </a>
            </div>

            {/* Email */}
            <div className="text-center p-8 bg-[#F5F5F5] rounded-lg hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[#6B2432] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-[#5A5A5A] mb-2">E-mail</h3>
              <p className="text-[#5A5A5A] mb-4">Envie sua dúvida</p>
              <a 
                href="mailto:contato@drluizrenatokreb.com.br"
                className="text-[#6B2432] font-semibold hover:underline break-all"
              >
                contato@drluizrenatokreb.com.br
              </a>
            </div>
          </div>

          {/* Office Hours */}
          <div className="bg-[#F5F5F5] rounded-lg p-8 text-center">
            <h3 className="text-2xl font-semibold text-[#5A5A5A] mb-6">
              Horários de Atendimento
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <div className="flex items-center justify-center mb-2">
                  <i className="ri-calendar-line text-[#6B2432] text-xl mr-2"></i>
                  <span className="font-semibold text-[#5A5A5A]">Segunda a Sexta</span>
                </div>
                <p className="text-[#5A5A5A]">8h30 às 18h00</p>
              </div>
              <div>
                <div className="flex items-center justify-center mb-2">
                  <i className="ri-calendar-line text-[#6B2432] text-xl mr-2"></i>
                  <span className="font-semibold text-[#5A5A5A]">Sábado</span>
                </div>
                <p className="text-[#5A5A5A]">8h30 às 12h00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
